<mat-card class="nav-card">
  <mat-card-content>
    <mat-nav-list aria-label="Left navigation">
      @if (isAuthenticated()) {
        @for (item of menuItems(); track item.label) {
          @if (item.visible) {
            <a mat-list-item [routerLink]="item.route" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" [attr.aria-label]="item.label">
              <mat-icon matListItemIcon aria-hidden="true" [fontIcon]="item.icon"></mat-icon>
              <span class="nav-label">{{ item.label }}</span>
              <mat-icon class="nav-arrow" aria-hidden="true" fontIcon="arrow_forward_ios"></mat-icon>
            </a>
          }
        }
        @if (isMobile()) {
          <a mat-list-item href="#" routerLinkActive="active-link" (click)="onLogout($event)" aria-label="Logout">
            <mat-icon matListItemIcon aria-hidden="true" fontIcon="logout"></mat-icon>
            <span class="nav-label">Logout</span>
            <mat-icon aria-hidden="true" class="nav-arrow" fontIcon="arrow_forward_ios"></mat-icon>
          </a>
        }
      } @else {
        <a mat-list-item href="#" routerLinkActive="active-link" (click)="onLogin($event, 'Citizen')" aria-label="Login as Consumer">
          <mat-icon matListItemIcon aria-hidden="true" fontIcon="login"></mat-icon>
          <span class="nav-label">Login as Consumer</span>
          <mat-icon aria-hidden="true" class="nav-arrow" fontIcon="arrow_forward_ios"></mat-icon>
        </a>

        <a mat-list-item href="#" routerLinkActive="active-link" (click)="onLogin($event, 'BusinessPartner')" aria-label="Login as Business Partner">
          <mat-icon matListItemIcon aria-hidden="true" fontIcon="login"></mat-icon>
          <span class="nav-label">Login as Business Partner</span>
          <mat-icon aria-hidden="true" class="nav-arrow" fontIcon="arrow_forward_ios"></mat-icon>
        </a>

        <a mat-list-item href="#" routerLinkActive="active-link" (click)="onLogin($event, 'CWOPA')" aria-label="Login as DHS Staff">
          <mat-icon matListItemIcon aria-hidden="true" fontIcon="login"></mat-icon>
          <span class="nav-label">Login as DHS Staff</span>
          <mat-icon aria-hidden="true" class="nav-arrow" fontIcon="arrow_forward_ios"></mat-icon>
        </a>
      }
    </mat-nav-list>
  </mat-card-content>
</mat-card>
